import { produce } from 'immer';

import { ENV_KEYS, EnvSchema } from '#core/schema/EnvSchema.ts';

/** Per-leaf-path coercions applied before validation; unlisted paths pass the raw string through. */
const ENV_VALUE_TRANSFORMS: Partial<Record<keyof typeof ENV_KEYS, (raw: string | undefined) => unknown>> = {
  strictMode: (raw) => raw === 'true',
};

// Build the EnvSchema.parse input from the ENV_KEYS manifest so the flat VITE_* ->
// nested shape mapping lives in exactly one place. See ENV_KEYS in EnvSchema.ts.
// TODO: https://github.com/alexmarqs/zod-config
const envInput = (Object.entries(ENV_KEYS) as [keyof typeof ENV_KEYS, string][]).reduce(
  (input, [leafPath, viteKey]) =>
    produce(input, (draft) => {
      const transform = ENV_VALUE_TRANSFORMS[leafPath];
      const raw = import.meta.env[viteKey];
      const value = transform ? transform(raw) : raw;
      const segments = leafPath.split('.');
      const leaf = segments.pop() as string;
      const parent = segments.reduce<Record<string, unknown>>((node, segment) => {
        node[segment] ??= {};
        return node[segment] as Record<string, unknown>;
      }, draft);
      parent[leaf] = value;
    }),
  {} as Record<string, unknown>,
);

export const env = EnvSchema.parse(envInput);
